// Đặt chiều cao menu xổ = full màn hình (theo scale mobile 768).
// Burger toggle .active do lib xử lý qua MJ__toogleActive + data-target="#Navigation".
function setBurgerInfoHeight() {
    const scaleWidthMB = 768;
    const scale = window.innerWidth / scaleWidthMB;
    const height = window.innerHeight / scale;
    $('#Navigation .burger-info').css('height', height + 'px');
}

window.addEventListener('load', function () {
    setBurgerInfoHeight();
    window.addEventListener('resize', setBurgerInfoHeight);
});
